import React, { useState, useEffect, useMemo } from "react";
import { Grid, Container } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { Tooltip } from "@progress/kendo-react-tooltip";
import { SimpleLoading, DialogSystemGLPure, PromotionalFooterPure, PanelBarGLPure, ButtonHLPure, ChatBoxGLPure, SubtitlePageHLPure, GridSelectionHLPure, BoxSomeHeadersGLPure, DialogPdf } from "../../pures";
import "./validate-repse-document.view.css";
import { ArrowBtnMobile, newProfileIcon } from "../../../assets/logos/icons";
import ChatAndDocumentView from "./chat-document";

const ValidateRepseDocumentView = (props) => {
    let {
        isLoading,
        showLoadingRequesting,
        toggleLoadingRequesting,
        showCompletedRequesting,
        toggleCompletedRequesting,
        showErrorRequesting,
        toggleErrorRequesting,
        messageError,
        handleClickBack,
        handleChangeStatus,
        handleValidateDocument,
        membersChat,
        conversation,
        handleInputChangeChat,
        createMessage,
        usersChat,
        documents,
        contract,
        workflowExecutionInfo,
        titleView,
        user
    } = props

    const { t } = useTranslation();

    const headerColumnOne = (props) => {
        return <span className="validateRepseDocumentView-header-cell-one">{props.title}</span>;
    };

    const headerColumnTwo = (props) => {
        return <span className="validateRepseDocumentView-header-cell-two">{props.title}</span>;
    };

    const headerColumnThree = (props) => {
        return <span className="validateRepseDocumentView-header-cell-three">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className='validateRepseDocumentView-cell-one'>
                <div className={"gridHLPure-containerLabel"}>
                    <span className="gridHLPure-userName">
                        {props.dataItem.documentName}
                    </span>
                    <div className="gridHLPure-detailsContainer">
                        <span className="gridHLPure-fieldSubtitle">
                            {props.dataItem.loadedDate}
                        </span>
                    </div>
                </div>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className='validateRepseDocumentView-cell-two'>
                <div className="">
                    <span className="gridHLPure-userName">
                        {props.dataItem.nameUser}
                    </span>
                </div>
            </td>
        );
    };


    const cellColumnThree = (props) => {
        return (
            <td className='validateRepseDocumentView-cell-three'>
                <div className="cellActions-containerAvatar">
                    {
                        props.dataItem.btnWatch ? (
                            <div className={"cellActions-containerBtnsDetails"}>
                                <button
                                    className="cellActions-btn"
                                    onClick={() => onClickWatchDoc(props.dataItem)}
                                >
                                    <p className="cellActions-textBotton">{t("validateRepseDocuments.btn.watch.doc")}</p>
                                </button>
                            </div>
                        ) : null
                    }
                    {
                        props.dataItem.btnReject ? (
                            <div className={"cellActions-containerBtnsDetails"}>
                            {
                                props.dataItem.isRejected ? (
                                    <p className="validateRepseDocumentView-label-rejected">{t("validateRepseDocuments.label.rejected")}</p>
                                ) : (
                                    <button
                                        className="cellActions-btn"
                                        onClick={() => onHandleReject(props.dataItem)}
                                    >
                                        <p className="cellActions-textBotton">{t("validateRepseDocuments.btn.reject.doc")}</p>
                                    </button>
                                )

                            }

                            </div>
                        ) : null
                    }
                </div>
                <div
                    className="cellActions-mobileExpanded"
                    onClick={() => handleShowDocumentsScreen(props.dataItem)}
                >
                    <img
                        className="cellActions-icon-arrow"
                        alt={"cellActions-arrow"}
                        src={ArrowBtnMobile}
                    />
                </div>
            </td>
        );
    }


    const [documentsGrid, setDocumentsGrid] = useState([])
    const [documentSelected, setDocumentSelected] = useState({})
    const [urlPdf, setUrlPdf] = useState('')
    const [showBackBtn, setShowBackBtn] = useState(false)
    const [showNextBtn, setShowNextBtn] = useState(false)
    const [backBtnLabel, setBackBtnLabel] = useState('')
    const [nextBtnLabel, setNextBtnLabel] = useState('')
    const [statusWorkflow, setStatusWorkflow] = useState(0)
    const [documentsRejected, setdocumentsRejected] = useState([])
    const[showPrincipalView, setShowPrincipalView] = useState(true)
    const[blob, setBlob] = useState("");
    const[nameElement, setNameElement] = useState('')
    
    let ENV = process.env
    const pdf = useMemo(() => <PdfReader className="pdfReader" url={urlPdf} awsURL showDownloadPDF={true} />, [urlPdf])

    useEffect(() => {
        if(!workflowExecutionInfo || !workflowExecutionInfo.workflowStatusDescriptions || !documents || documents.length === 0 || !user)  return
        //verify if user has permission
        let statusComplete = workflowExecutionInfo.workflowStatusDescriptions
        let statusCurrent = statusComplete.statusCurrent.status
        let userHasPermission = false
        let userEmail = user.userMetaData.userA3Cloud.email
        let member = workflowExecutionInfo.workflowExecutionMembers.find((member) => member.email === userEmail)
        if(member && member.workflowExecutionMemberTypeId === Number(ENV.REACT_APP_AUTHORIZER_REPSE_DOCUMENTS)){
            userHasPermission = true
        }

        //verify if document is rejected
        let documentsWereRejected = []
        let documentsComplete = documents.map((documento) => {
            documento.btnWatch = true
            if(userHasPermission && statusCurrent === Number(ENV.REACT_APP_STATUS_REPSE_VALIDATE)){
                documento.btnReject = true
                if(documento.statusDocumentId && documento.statusDocumentId === Number(ENV.REACT_APP_STATUS_REPSE_DOCUMENT_REJECTED)){
                    documento.isRejected = true
                    documentsWereRejected.push(documento)
                }else{
                    documento.isRejected = false
                }
            }else{
                documento.btnReject = false
            }
            return documento
        })

        let url = documents[0].path

        // verify workflow status to show buttons
        let showBackBtn = (statusComplete.statusBack && statusComplete.statusBack.status && statusComplete.statusBack.status > 0 && statusCurrent === Number(ENV.REACT_APP_STATUS_REPSE_VALIDATE) && userHasPermission) ? true : false
        let showNextBtn = (statusComplete.statusNext && statusComplete.statusNext.status && statusComplete.statusNext.status > 0  && statusCurrent === Number(ENV.REACT_APP_STATUS_REPSE_VALIDATE) && userHasPermission) ? true : false

        let labelBackBtn = (statusComplete.statusBack && statusComplete.statusBack.status && statusComplete.statusBack.status > 0 && userHasPermission) ? statusComplete.statusBack.name : ''
        let labelNextBtn = (statusComplete.statusNext && statusComplete.statusNext.status && statusComplete.statusNext.status > 0 && userHasPermission) ? statusComplete.statusNext.name : ''

        setShowBackBtn(showBackBtn)
        setShowNextBtn(showNextBtn)
        setBackBtnLabel(labelBackBtn)
        setNextBtnLabel(labelNextBtn)
        setDocumentsGrid(documentsComplete)
        setUrlPdf(url)
        setStatusWorkflow(statusCurrent)
        setdocumentsRejected(documentsWereRejected)
    },[workflowExecutionInfo, documents, user])


    const onClickWatchDoc = (dataItem) => {
        setUrlPdf(dataItem.path)
    }

    const onHandleReject = (dataItem) => {
        let documentsWereRejected = [...documentsRejected]
        let docExist = documentsWereRejected.find((documento) => documento.id === dataItem.id)
        if(!docExist){
            documentsWereRejected.push(dataItem)
            documentsWereRejected = documentsWereRejected.map((documento) => {
                if(documento.id === dataItem.id){
                    documento.isRejected = true
                }
                
                return documento
            })
            setdocumentsRejected(documentsWereRejected)
        }
    }

    const handleChangeWorkflow = (action) => {
        let documentsRejectedToSend
        if(statusWorkflow  === Number(ENV.REACT_APP_STATUS_REPSE_VALIDATE) && action === 'back'){
            documentsRejectedToSend = [...documentsRejected]
        }
        
        handleChangeStatus(action, documentsRejectedToSend)
    }

    const handleChangeScreen = (value) => {
        setShowPrincipalView(value)
    }

    const handleShowChat = () => {
        setNameElement('chat')
        setShowPrincipalView(false)
    }
    
    const handleShowDocumentsScreen = (document) => {
        setBlob(document.path);
        setDocumentSelected(document)
        setShowPrincipalView(false)
        setNameElement('document')
    }

    const handleValidate = () => {
        if(documentsRejected && documentsRejected.length > 0){
            let errorMessage = t("validateRepseDocumentView.error.rejected")
            toggleErrorRequesting(true, errorMessage, 4000)
            return
        }
        handleValidateDocument()
    }

    return (
        <div className="validateRepseDocumentView-wrapper">
            {isLoading ? (
                <SimpleLoading />
            ) : (
                <Container
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    spacing={4}
                    className="validateRepseDocumentView-container"
                >
                    <Grid
                        item
                        lg={12}
                        md={12}
                        xs={12}
                        sm={12}
                        className='validateRepseDocumentView-navbar'
                    >
                        <SubtitlePageHLPure
                            subtitle={titleView}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        className='validateRepseDocumentView-body'
                    >
                        <BoxSomeHeadersGLPure
                            titleOne={t("validateRepseDocumentView.company")}
                            subtitleOne={contract.companyName}
                            titleTwo={t('validateRepseDocumentView.title.provider')}
                            subtitleTwo={contract.contractorName}
                            titleThree={t("validateRepseDocumentView.contract")}
                            subtitleThree={contract.name}
                            titleFour={t("validateRepseDocuments.yearMonth")}
                            subtitleFour={contract.yearMonth}
                        />
                        {
                            showPrincipalView ? (
                                <>
                                    
                                    <div className="validateRepseDocumentView-container-grid-pdf">
                                        <div className="validateRepseDocumentsView-panel-bars">
                                            <PanelBarGLPure
                                                expandedPanel={true}
                                                titlePanel={t("validateRepseDocuments.panel.bar.1")}
                                            >
                                                <Grid item className={(documentsGrid.length > 7) ? "validateRepseDocumentView-grid-documents-scroll" : "validateRepseDocumentView-grid-documents"}>
                                                    <GridSelectionHLPure
                                                        styleGeneral={true}
                                                        styleGeneralClass={"validateRepseDocumentView-general-grid"}
                                                        pageable={false}
                                                        skip={0}
                                                        take={documentsGrid.length}
                                                        dataGrid={documentsGrid}
                                                        filter={true}
                                                        onSelectedItem={setDocumentSelected}
                                                        setNameComponentUser={() => console.log('')}
                                                        setShowDetails={() => console.log('')}
                                                        columnTwo={true}
                                                        columnThree = {true}
                                                        columnFive={false}
                                                        titleRow1={t("validateRepseDocuments.title.column.1")}
                                                        titleRow2={t("validateRepseDocuments.title.column.2")}
                                                        titleRow3={t("validateRepseDocuments.title.column.3")}
                                                        headerColumnOne={headerColumnOne}
                                                        cellColumnOne={cellColumnOne}
                                                        headerColumnTwo={headerColumnTwo}
                                                        cellColumnTwo={cellColumnTwo}
                                                        headerColumnThree = {headerColumnThree}
                                                        cellColumnThree = {cellColumnThree}
                                                        styleGrid={{ height: '400px' }}
                                                    />
                                                </Grid>
                                            </PanelBarGLPure>
                                            <div className='validateRepseDocuments-panel-bar-two'>
                                                <PanelBarGLPure
                                                    expandedPanel={true}
                                                    titlePanel={t("validateRepseDocuments.panel.bar.2")}
                                                >
                                                    <>
                                                        <Grid className="validateRepseDocumentView-headerUsersChat">
                                                            <span className="validateRepseDocumentView-titleGrid">
                                                                {t("validateRepseDocuments.chat.title")}
                                                            </span>
                                                            <div className="validateRepseDocumentView-containersAvatars">
                                                                {membersChat.map((item, index) => (
                                                                    <div>
                                                                        <Tooltip
                                                                            openDelay={600}
                                                                            position="bottom"
                                                                            anchorElement="target"
                                                                            tooltipClassName="tooltipGeneralStyle"
                                                                        >
                                                                            <div>
                                                                                <img
                                                                                    title={item.name}
                                                                                    key={index}
                                                                                    src={
                                                                                        item.avatarUrl && item.avatarUrl !== ""
                                                                                            ? item.avatarUrl
                                                                                            : newProfileIcon
                                                                                    }
                                                                                    className="followUpActionsContractsView-avatar"
                                                                                    alt={item.name}
                                                                                />
                                                                            </div>
                                                                        </Tooltip>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Grid>
                                                        <ChatBoxGLPure
                                                            user={usersChat}
                                                            conversation={conversation}
                                                            widthChat={1200}
                                                            heightChat={300}
                                                            placeholderChat={t("chatBoxGLPure.placeholder")}
                                                            handleInputChange={handleInputChangeChat}
                                                            createMessage={createMessage}
                                                        />
                                                    </>
                                                </PanelBarGLPure>
                                            </div>
                                        </div>
                                        <div className="validateRepseDocumentView-card-template" >
                                            {pdf}
                                        </div>
                                    </div>
                                    <div className="validateRepseDocumentView-container-btns">
                                        <div className="validateRepseDocumentView-btns">
                                            <ButtonHLPure
                                                nameBtn={t('followUpActionsContractsView.button.exit')}
                                                primary={false}
                                                onClickBtn={handleClickBack}
                                            />
                                        </div>
                                        <div className="validateRepseDocumentView-btn-chat">
                                            <ButtonHLPure
                                                nameBtn={'Ver chat'}
                                                primary={false}
                                                onClickBtn={() => handleShowChat()}
                                            />                                    
                                        </div>
                                        {
                                            showBackBtn && (
                                                <div className="validateRepseDocumentView-btns">
                                                    <ButtonHLPure
                                                        nameBtn={backBtnLabel}
                                                        primary={false}
                                                        onClickBtn={() => handleChangeWorkflow('back')}
                                                    />
                                                </div>
                                            )
                                        }
                                        
                                        {
                                            showNextBtn && (
                                                <ButtonHLPure
                                                    nameBtn={nextBtnLabel}
                                                    primary={true}
                                                    onClickBtn={() => handleValidate()}
                                                />
                                            )
                                        }
                                        
                                    </div>
                                </>
                            ) : (
                                
                               <div className="validateRepseDocumentView-chat-documento">
                                    <ChatAndDocumentView 
                                        blob={blob}
                                        showBackBtn={showBackBtn}
                                        onHandleReject={onHandleReject}
                                        documentSelected={documentSelected}
                                        handleChangeScreen={handleChangeScreen}
                                        nameElement={nameElement}
                                        usersChat={usersChat}
                                        conversation={conversation}
                                        handleInputChangeChat={handleInputChangeChat}
                                        createMessage={createMessage}
                                        membersChat={membersChat}
                                    />
                               </div>
                            )
                        }
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <PromotionalFooterPure />
                        </Grid>
                    </Grid>
                    {
                        showCompletedRequesting || showLoadingRequesting || showErrorRequesting ?
                            <DialogSystemGLPure
                                showLoadingRequesting={showLoadingRequesting}
                                showCompletedRequesting={showCompletedRequesting}
                                showErrorRequesting={showErrorRequesting}
                                toggleLoadingRequesting={toggleLoadingRequesting}
                                toggleCompletedRequesting={toggleCompletedRequesting}
                                toggleErrorRequesting={toggleErrorRequesting}
                                message={messageError}
                            />
                            : null
                    }
                </Container>
            )
            }
        </div>
    );
}

export default ValidateRepseDocumentView;